var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGastronomy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#b86000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.125 6.125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.188,33.25c.711,0,1.313-1,1.313-2.187s-.6-2.187-1.312-2.187-1.312,1-1.312,2.188S77.476,33.25,78.188,33.25Zm2.188-2.187a2.948,2.948,0,0,1-1.75,3V43.75H77.75V34.065a2.948,2.948,0,0,1-1.75-3C76,29.346,76.961,28,78.188,28S80.375,29.346,80.375,31.063Z",
    transform: "translate(-65.5 -28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,31.935a1.313,1.313,0,1,1-2.625,0V28H28v3.938a2.117,2.117,0,0,0,1.75,2.141V43.75h.875V34.079a2.117,2.117,0,0,0,1.75-2.141V28H31.5Z",
    transform: "translate(-28 -28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,32.375h.875V28H36Z",
    transform: "translate(-34.25 -28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.75,35.875h-.875v-7c.695,0,.875.45.875,2.188ZM56.875,28H56V43.75h.875v-7h1.75V31.063C58.625,29.843,58.625,28,56.875,28Z",
    transform: "translate(-49.875 -28)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGastronomy);
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' viewBox='0 0 28 28'%3e%3ccircle cx='14' cy='14' r='14' fill='%23b86000'/%3e%3cg transform='translate(6.125 6.125)'%3e%3cpath d='M78.188,33.25c.711,0,1.313-1,1.313-2.187s-.6-2.187-1.312-2.187-1.312,1-1.312,2.188S77.476,33.25,78.188,33.25Zm2.188-2.187a2.948,2.948,0,0,1-1.75,3V43.75H77.75V34.065a2.948,2.948,0,0,1-1.75-3C76,29.346,76.961,28,78.188,28S80.375,29.346,80.375,31.063Z' transform='translate(-65.5 -28)' fill='%23fff'/%3e%3cpath d='M31.5,31.935a1.313,1.313,0,1,1-2.625,0V28H28v3.938a2.117,2.117,0,0,0,1.75,2.141V43.75h.875V34.079a2.117,2.117,0,0,0,1.75-2.141V28H31.5Z' transform='translate(-28 -28)' fill='%23fff'/%3e%3cpath d='M36,32.375h.875V28H36Z' transform='translate(-34.25 -28)' fill='%23fff'/%3e%3cpath d='M57.75,35.875h-.875v-7c.695,0,.875.45.875,2.188ZM56.875,28H56V43.75h.875v-7h1.75V31.063C58.625,29.843,58.625,28,56.875,28Z' transform='translate(-49.875 -28)' fill='%23fff'/%3e%3c/g%3e%3c/svg%3e";
export { ForwardRef as ReactComponent };